<div class="app-bookmarks-dialog">
  <div class="header">
    <h3>Add a Charger</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content" #dialogContainer>
    <div style="margin-bottom: 10px">
      <div style="font-weight:500">Charger details</div>
      <div style="margin-top:5px;color:#888;font-size:.9rem;">Provide some information about this place. If this place is added to Maps, it will appear publicly.</div>
    </div>

    <form class="charger-form" (ngSubmit)="submitForm()" [formGroup]="formGroup">
      <div class="error-message" *ngIf="state() === 'error'">
        <mat-icon>error</mat-icon>
        Something went wrong. Please try again later.
      </div>

      <div class="success-message" *ngIf="state() === 'success'">
        <mat-icon>check_circle</mat-icon>
        Station added successfully.
        <a [routerLink]="['/station', createdStationId]" (click)="close()">
          View station details
          <mat-icon>arrow_right_alt</mat-icon>
        </a>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Charger name</mat-label>
        <input matInput required formControlName="name">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Location type</mat-label>
        <mat-select required formControlName="locationTypeId">
          <mat-option *ngFor="let type of locationTypes" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Address</mat-label>
        <input matInput required [matAutocomplete]="auto" formControlName="address">
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onAddressSelected($event)">
          @for (option of searchedAddresses; track option) {
            <mat-option [value]="option">{{ option?.address?.formattedAddress }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Map placeholder -->
      <div class="map-placeholder" style="margin-bottom:16px" (click)="openMapDialog()">
        <div id="map-preview"></div>
        <img src="assets/map/icons/DefaultMarker.svg" class="map-preview-marker" />
        <button class="edit-map-location" type="button">
          <mat-icon>edit_location_alt</mat-icon>
          Edit map location
        </button>
      </div>

      <!-- Hours -->
      <button type="button" class="hours-input" (click)="openHoursDialog()">
        @if (hours?.open24Hours) {
          <span>Hours: Open 24 hours</span>
        } @else if (hours?.dayHours) {
          <span>
            <p *ngFor="let day of daysOfWeek">
              <span>{{ WEEKDAYS[day] }}: </span>
              <span>
                @for (hour of hours.dayHours[day]; track hour) {
                  <span *ngIf="hour?.open && hour?.close">{{ formatTime(hour.open) }}—{{ formatTime(hour.close) }}<span *ngIf="!$last">, </span></span>
                  <span *ngIf="!hour?.open || !hour?.close">Closed</span>
                }
              </span>
            </p>
          </span>
        } @else {
          <span>Hours</span>
        }
        <mat-icon>chevron_right</mat-icon>
      </button>

      <!-- Contact -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Phone number</mat-label>
        <input matInput formControlName="phone">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Website</mat-label>
        <input matInput type="url" formControlName="website">
      </mat-form-field>

      <!-- Photos -->
      <div class="photo-upload">
        <div style="margin-bottom: 10px">
          <div style="font-weight:500">Add photos</div>
          <div style="margin-top:5px;color:#888;font-size:.9rem;">
            Add helpful photos like storefronts, notices, or signs (optional)
          </div>
          <div style="margin-top:12px;color:#333;font-size:.9rem;display: flex;align-items: center;gap: 8px;">
            <div class="avatar">
              <span>{{ user()?.displayName?.charAt(0) }}</span>
              <app-gc-image [src]="getUserPhoto?.(user().uid)" alt="" />
            </div>
            {{ user()?.displayName }}
          </div>
        </div>

        <div *ngIf="imagePreviews.length === 0">
          <button mat-stroked-button color="primary" (click)="fileInput.click()" type="button">
            <mat-icon>add_a_photo</mat-icon>
            Add photos
          </button>
        </div>

        <input
          type="file"
          #fileInput
          multiple
          accept="image/*"
          hidden
          (change)="onFilesSelected($event)"
        />

        <div class="previews" *ngIf="imagePreviews.length > 0">
          <button mat-stroked-button color="primary" (click)="fileInput.click()" type="button" class="add-photos-button">
            <mat-icon>add_a_photo</mat-icon>
          </button>
          <div class="images">
            <ng-container *ngFor="let img of imagePreviews">
              <div class="image-item">
                <img [src]="img" alt="Preview" class="preview-image" />
                <button mat-icon-button class="remove-image-button" (click)="removeImage(img)" type="button">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="actions">
        <button mat-button type="button" (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="state() === 'loading' || formGroup.invalid">
          <mat-spinner *ngIf="state() === 'loading'" diameter="20"></mat-spinner>
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
